import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

import { getCreateContractRoute } from "../../../../../../routers/routeUtils";

import { ServiceRequest } from "../../../../types/service.type";
import CreateContractFigure from "../../../../assets/images/create-contract-img.png";

const CreateContract = ({
  serviceRequest,
  isServiceRequestLoading,
}: {
  serviceRequest?: ServiceRequest;
  isServiceRequestLoading: boolean;
}) => {
  const { t } = useTranslation("goService", {
    keyPrefix: "serviceRequestPage",
  });

  const navigate = useNavigate();

  const requestId = serviceRequest?.id;
  const serviceId = serviceRequest?.service?.id;

  const handleCreateContract = () => {
    if (!requestId || !serviceId) return;
    navigate(getCreateContractRoute(requestId, serviceId));
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.content}>
        <Box component="img" src={CreateContractFigure} alt="create-contract-figure" sx={styles.figure} />
        <Typography sx={styles.title}>{t("noContracts")}</Typography>
      </Box>
      <Button
        variant="primary-md"
        sx={{ width: "fit-content" }}
        onClick={handleCreateContract}
        disabled={isServiceRequestLoading}
      >
        {t("createContract")}
      </Button>
    </Box>
  );
};

export default CreateContract;

const styles = {
  container: {
    height: "fit-content",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
    display: "flex",
    padding: "80px 20px",
    flexDirection: "column",
    alignItems: "center",
    gap: "40px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  title: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    textAlign: "center",
  },
  figure: {
    width: "92.711px",
    height: "111.427px",
  },
};
